export type ScreensMessagesContent = {
  analytics: {
    viewed_event: string
    clicked_event: string
    error_event: {
      name: string
      segment: {
        [err: string]: string
      }
    }
  }
  typesOfScreens: { [key: string]: string }
  successScreenStatus: { [key: string]: boolean }
  uRLQueryStrings: { [key: string]: string }
  errorStatus: {
    [types: string]: {
      hasIcon: boolean
      success: boolean
      hasSupportLink: boolean
      hasLogin: boolean
    }
  }
}

// for local dev testing
// localhost:9000/user-email-verification?context_name=dev-T01A-client&supportSignUp=true&supportForgotPassword=true&email=cotter%2B0810_blockacc%40akiliinteractive.com&message=Your+email+was+verified.+You+can+continue+using+the+application.&success=true&code=success

const screensMessagesContent = {
  analytics: {
    viewed_event: 'Screen_viewed',
    clicked_event: 'DownloadApp_clicked',
    error_event: {
      name: 'Auth0Status',
      segment: {
        code: 'auth0_code',
        message: 'auth0_message',
        success: 'auth0_success'
      }
    }
  },
  typesOfScreens: {
    success: 'success',
    expired: 'expired',
    already: 'already',
    used_once: 'used_once',
    generic: 'generic'
  },
  successScreenStatus: {
    success: true,
    expired: false,
    already: true,
    used_once: true,
    generic: false
  },
  uRLQueryStrings: {
    success: 'Your email was verified. You can continue using the application.',
    expired: 'Access expired.',
    already: 'This account is already verified.',
    used_once: 'This URL can be used only once'
  },
  errorStatus: {
    expired: {
      hasIcon: true,
      success: false,
      hasSupportLink: true,
      hasLogin: false
    },
    generic: {
      hasIcon: true,
      success: false,
      hasSupportLink: true,
      hasLogin: false
    }
  }
}
export default screensMessagesContent
